import { useRaysyncStore } from '@/store/raysync/raysync-store'
import { useCallback } from 'react'
import { IGetTransferServerLineList } from '@/store/raysync/type'
import { RaysyncAPI } from '@/store/raysync/service'
import { useOutputStore } from '@/store/output/output-store'

export function useTransferLine() {
  const isBreakingVersion = useRaysyncStore((state) => state.isBreakingVersion)
  const fileShareInfo = useOutputStore((state) => state.fileShareInfo)

  const getCurrentTransferLine = useCallback(async () => {
    const { data } = await RaysyncAPI.getTransferServerLineList(
      { zone: fileShareInfo?.zone || 0 },
      {
        headers: {
          platform: fileShareInfo?.platform,
        },
      },
    )
    const versionType = isBreakingVersion() ? 2 : 1
    const line: IGetTransferServerLineList[] | undefined = data?.filter(
      (item) => item.versionType === versionType,
    )
    return line?.[0]?.name ?? ''
  }, [fileShareInfo?.zone, fileShareInfo?.platform])

  return {
    getCurrentTransferLine,
  }
}
